import { IProjectFilter } from '../../../models';
import { EProjectsActions } from './enums';
import { getFilters as getFiltersService, getProject as getProjectService, getProjects as getProjectsService } from './services';

export const getProjects = (filter: IProjectFilter | null, page?: number) => ({
    type: EProjectsActions.GET_PROJECTS,
    payload: getProjectsService(filter, page),
});

export const getFilters = () => ({
    type: EProjectsActions.GET_FILTERS,
    payload: getFiltersService(),
});

export const getProject = (name: string) => ({
    type: EProjectsActions.GET_PROJECT,
    payload: getProjectService(name)
});
